if (!customElements.get('peptia-objectives')) {
  customElements.define('peptia-objectives', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.track = this.querySelector('.protocol-track');
      if (!this.track) return;
      this.track.querySelectorAll('[data-loop-clone]').forEach(p=>p.remove());
      this.pages = [...this.track.querySelectorAll('.protocol-page')];
      if (!this.pages.length) return;
      this.previous=this.querySelector('.prev'); this.next=this.querySelector('.next');
      this.index=0; this.loop=false; this.copies=0;
      this.previous?.addEventListener('click',()=>this.move(-1),options);
      this.next?.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('scroll',()=>{this.update();clearTimeout(this.timer);this.timer=setTimeout(()=>this.settle(),160);},{...options,passive:true});
      this.track.addEventListener('scrollend',()=>this.settle(),options);
      this.track.addEventListener('pointerdown',()=>{this.dragging=true;},options);
      ['pointerup','pointercancel'].forEach(type=>window.addEventListener(type,()=>{this.dragging=false;},options));
      this.track.addEventListener('keydown',e=>{
        if(e.target!==this.track)return;
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}
        else if(e.key==='Home'||e.key==='End'){e.preventDefault();this.select(e.key==='Home'?0:this.pages.length-1);}
      },options);
      this.addEventListener('shopify:block:select',e=>{const i=this.pages.findIndex(p=>p.contains(e.target));if(i>=0)this.select(i);},options);
      this.observer?.disconnect();this.observer=new ResizeObserver(()=>this.measure());this.observer.observe(this.track);
      document.fonts.ready.then(()=>{if(this.isConnected)this.measure();});this.measure();
    }
    clone(page) {
      const p=page.cloneNode(true);p.dataset.loopClone='';p.setAttribute('aria-hidden','true');p.removeAttribute('data-shopify-editor-block');p.removeAttribute('id');
      p.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));
      p.querySelectorAll('a,button,input,[tabindex]').forEach(e=>e.setAttribute('tabindex','-1'));
      return p;
    }
    measure() {
      const width=this.track.clientWidth;if(!width)return;
      const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;
      const content=this.pages.reduce((sum,p)=>sum+p.offsetWidth,0)+gap*this.pages.length;
      if(!content)return;
      const desktop=matchMedia('(min-width:750px)').matches;
      const loop=!desktop&&this.pages.length>1, copies=loop?Math.max(1,Math.ceil(width/content)):0, index=this.index;
      this.classList.toggle('is-fitting',desktop);
      this.track.tabIndex=desktop?-1:0;
      if(copies!==this.copies){
        this.track.querySelectorAll('[data-loop-clone]').forEach(p=>p.remove());
        if(loop){
          const group=()=>Array.from({length:copies},()=>this.pages.map(p=>this.clone(p))).flat();
          this.track.prepend(...group());this.track.append(...group());
        }
        this.copies=copies;
      }
      this.loop=loop;
      this.querySelector('.protocol-nav').hidden=!loop;
      const hint=this.querySelector('.protocol-hint');if(hint)hint.hidden=!loop;
      this.allPages=[...this.track.querySelectorAll('.protocol-page')];
      this.origin=this.allPages[0].offsetLeft;this.start=this.pages[0].offsetLeft-this.origin;
      this.period=loop?this.allPages[(copies+1)*this.pages.length].offsetLeft-this.pages[0].offsetLeft:0;
      this.jump(desktop?0:this.pages[index].offsetLeft-this.origin);this.update();
    }
    jump(left) {
      this.track.style.scrollSnapType='none';this.track.scrollTo({left,behavior:'instant'});
      cancelAnimationFrame(this.jumpFrame);this.jumpFrame=requestAnimationFrame(()=>this.track.style.removeProperty('scroll-snap-type'));
    }
    nearest() {
      const x=this.track.scrollLeft;
      return this.allPages.reduce((best,p,i)=>Math.abs(p.offsetLeft-this.origin-x)<Math.abs(this.allPages[best].offsetLeft-this.origin-x)?i:best,0);
    }
    update() {
      if(!this.allPages?.length)return;
      this.index=this.nearest()%this.pages.length;
      if(this.previous)this.previous.disabled=this.pages.length<2;if(this.next)this.next.disabled=this.pages.length<2;
      this.querySelector('.protocol-count strong').textContent=String(this.index+1).padStart(2,'0');
      this.querySelector('.protocol-progress span').style.width=((this.index+1)/this.pages.length*100)+'%';
    }
    settle() {
      if(!this.loop||!this.period||this.dragging)return;
      const x=this.track.scrollLeft,normalized=this.start+((x-this.start)%this.period+this.period)%this.period;
      if(Math.abs(x-normalized)>1)this.jump(normalized);this.update();
    }
    move(direction) {if(!this.loop)return;this.settle();const p=this.allPages[this.nearest()+direction];if(p)this.scrollToPage(p);}
    select(index) {this.scrollToPage(this.pages[((index%this.pages.length)+this.pages.length)%this.pages.length]);}
    scrollToPage(p) {this.track.scrollTo({left:p.offsetLeft-this.origin,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer);cancelAnimationFrame(this.jumpFrame);}
  });
}

